<ngx-loading-bar [includeSpinner]="false" [color]="'#58f357'"></ngx-loading-bar>
<div #rootBlock>
  <router-outlet (activate)="componentAdded($event)"></router-outlet>
</div>

